module.exports = __webpack_public_path__ + "static/img/manual_ja_40.69670a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_40.png
// module id = jm0N
// module chunks = 4